import React from 'react';
import { CTAButton } from './CTAButton';
import { ProductMockup } from './ProductMockup';
export function Hero() {
  return <section className="relative h-[100dvh] md:h-auto md:min-h-0 md:pt-32 md:pb-24 overflow-hidden flex flex-col" data-id="element-109">
      {/* Background Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-amber-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-110"></div>

      <div className="container mx-auto px-4 relative z-10 flex flex-col justify-between flex-1 py-4 md:py-0 md:block" data-id="element-111">
        {/* Title Block */}
        <div className="max-w-4xl mx-auto text-center mb-1 md:mb-12" data-id="element-112">
          <p className="text-amber-500 font-bold tracking-widest uppercase text-[10px] md:text-base mb-1 md:mb-4" data-id="element-113">
            El Sistema Maestro Centenario del Asado Argentino
          </p>
          <h1 className="text-[17px] leading-snug md:text-4xl lg:text-5xl font-sans font-extrabold text-white md:leading-tight mb-1 md:mb-6" data-id="element-114">
            Che, ¿vas a seguir improvisando en la parrilla o vas a aprender de
            una vez?
          </h1>
          <p className="text-xs md:text-xl text-zinc-400 max-w-2xl mx-auto md:mb-8 border-l-2 md:border-l-4 border-amber-500 pl-2 md:pl-4 text-left md:text-center md:border-l-0 md:pl-0 leading-snug" data-id="element-115">
            Porque en Argentina el asado no se hereda. Se aprende. Y este es el
            sistema.
          </p>
        </div>

        {/* Product Mockup — DOMINANT on mobile */}
        <div className="max-w-[260px] md:max-w-sm mx-auto my-1 md:mb-6 flex-shrink-0" data-id="element-116">
          <ProductMockup data-id="element-117" />
        </div>

        {/* Badge below mockup */}
        <div className="text-center mb-1 md:mb-16" data-id="element-118">
          <div className="inline-block bg-zinc-900 border border-zinc-800 rounded-full px-3 md:px-6 py-0.5 md:py-2" data-id="element-119">
            <span className="text-amber-400 font-semibold text-[10px] md:text-base" data-id="element-120">
              NUEVO
            </span>
            <span className="text-zinc-500 mx-1 md:mx-2 text-[10px] md:text-base" data-id="element-121">
              —
            </span>
            <span className="text-zinc-300 text-[10px] md:text-base" data-id="element-122">
              11 Tomos + 4 Bonos · Descarga inmediata
            </span>
          </div>
        </div>

        {/* Bullet Points + CTA — pushed to bottom on mobile */}
        <div className="max-w-3xl mx-auto" data-id="element-123">
          <ul className="space-y-0.5 md:space-y-6 mb-2 md:mb-10" data-id="element-124">
            {['🥩 Del mostrador de la carnicería al aplauso en la mesa', '🔥 Fuego, brasa, altura y tiempos explicados de verdad', '💰 Cortes económicos que saben a premium', '🌾 Técnicas de campo que los gauchos usaron por generaciones', '🆘 Protocolo de rescate para cuando algo se va al carajo', '✅ Para el que empieza de cero y para el que ya hace asados'].map((item, i) => <li key={i} className="flex items-start text-[11px] leading-tight md:text-lg text-zinc-300" data-id="element-125">
                <span className="mr-1.5 md:mr-3 flex-shrink-0" data-id="element-126">
                  {item.substring(0, 2)}
                </span>
                <span data-id="element-127">{item.substring(3)}</span>
              </li>)}
          </ul>
          <div className="text-center pb-2 md:pb-0" data-id="element-128">
            <p className="text-sm md:text-xl font-bold text-white mb-2 md:mb-6" data-id="element-129">
              Pago único $19.990 ARS · Acceso inmediato
            </p>
            <CTAButton data-id="element-130" />
          </div>
        </div>
      </div>
    </section>;
}